<template>
  <div id="app" class="wrapper">
    <div class="spMenuModal">
      <div class="spMenuModal__overlay"></div>
    </div>
    <Header :roomNo="roomNo"></Header>
    <div class="l-defalutLayout__mainVisual" v-if="mainVisualShow">
      <aside>
        <img
          :src="
            `/assets/custom/${currentUser.mansion.dai_bunrui}/${currentUser.mansion.chu_bunrui}/${currentUser.mansion.id}/img/mainVisual.jpg`
          "
          alt="mainVisual"
        />
      </aside>
    </div>
    <main class="l-defalutLayout__mainWrap">
      <div class="l-defalutLayout__main">
        <GlobalNav :type="currentUser.status" :roomNo="roomNo" />
        <div class="l-defalutLayout__main__container">
          <router-view></router-view>
          <div class="l-defalutLayout__calendar">
            <Calender />
          </div>
        </div>
      </div>
    </main>
    <Footer></Footer>
    <ButtonScrollInPageTop></ButtonScrollInPageTop>
  </div>
</template>

<script>
import store from "@/store";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ButtonScrollInPageTop from "@/components/ButtonScrollInPageTop.vue";
// import NaviListMobileContractor from "../components/NaviListMobileContractor.vue";
// import NaviListMobileResident from "../components/NaviListMobileResident.vue";
// import NaviListContractor from "../components/NaviListContractor.vue";
// import NaviListResident from "../components/NaviListResident.vue";
import GlobalNav from "@/components/GlobalNav.vue";
import Calender from "@/components/Calender.vue";

export default {
  components: {
    Header,
    Footer,
    ButtonScrollInPageTop,
    // NaviListMobileContractor,
    // NaviListMobileResident,
    // NaviListResident,
    // NaviListContractor,
    GlobalNav,
    Calender,
  },
  name: "default-layout",
  beforeMount() {
    console.log("default-layout beforeMount");
    const currentUser = store.state.auth.user;
    console.log("currentUser", currentUser);

    if (
      currentUser != null &&
      currentUser.mansion._id != this.$route.params.mc_code
    ) {
      this.$router.push({
        name: "notfound404",
      });
    }
    if (!currentUser.email) {
      this.$router.push({
        name: "email-required",
        params: { mc_code: currentUser.mansion._id },
      });
    }
  },
  async mounted() {
    console.log("default-layout mounted");
    var routeInstance = this.$route;
    await this.$nextTick();
    this.createTitleDesc(routeInstance);
    this.appendFile();
    window.initMenu();

    this.mainVisualShowToggle();
  },
  computed: {
    roomNo() {
      return this.currentUser ? this.currentUser.roomNo : "";
    },
    isShow() {
      const ignorePaths = [
        "login",
        "password-reminder",
        "notfound404",
        "verify-email",
      ];
      //
      //
      return (
        ignorePaths.indexOf(this.$route.name) == -1 && this.currentUser != null
      );
    },
    mansionName() {
      //
      //
      if (this.mansion) {
        return this.mansion.name ? this.mansion.name : "";
      } else {
        return "";
      }
    },
    user() {
      return this.currentUser;
    },
    showAdminBoard() {
      return true;
      // if (this.currentUser && this.currentUser.role) {
      //   // eslint-disable-next-line
      //
      //   return this.currentUser.role == "Admin";
      // }

      // return false;
    },
    showModeratorBoard() {
      return true;
      // if (this.currentUser && this.currentUser.roles) {
      //   return this.currentUser.roles.includes("ROLE_MODERATOR");
      // }

      // return false;
    },
  },
  watch: {
    // eslint-disable-next-line
    $route(routeInstance, from) {
      //メインビジュアルを表示、非表示
      this.mainVisualShowToggle();
      this.createTitleDesc(routeInstance);
    },
  },
  data() {
    return {
      mainVisualShow: true,
      defaultIndex: "/",
    };
  },
  methods: {
    mainVisualShowToggle() {
      if (
        window.location.href ===
        window.location.origin + "/" + this.$route.params.mc_code
      ) {
        this.mainVisualShow = true;
      } else {
        this.mainVisualShow = false;
      }
    },
    appendCSS(filePath) {
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = filePath;
      document.head.appendChild(file);
    },
    role2Ja: function(role) {
      const roleNames = {
        Admin: "管理者",
        ExternalParty: "外部関係者",
        Chairman: "理事長",
        Director: "理事",
        OwnedResident: "区分所有者",
        OwnedNonResident: "外部オーナー",
        RentResident: "賃借人",
        Others: "その他",
      };
      return roleNames[role];
    },
  },
};
</script>

<style></style>
